// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  min-width: unset !important;
}

.App {
  text-align: center;
}

.App-logo {
  animation: App-logo-spin infinite 20s linear;
  height: 80px;
}

.App-header {
  background-color: #222;
  height: 150px;
  padding: 20px;
  color: white;
}

.App-title {
  font-size: 1.5em;
}

.App-intro {
  font-size: large;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.loading-page {
  position: absolute;
  width: 100%;
  left: 0;
  background-color: #4330ff;
}

.hide {
  display: none;
}

.clear {
  clear: both;
}

.helper-text:hover {
  cursor: help;
}

.note-buttons {
  float: right;
}

.save-note-button {
  cursor: pointer;
  margin-top: 10px;
  width: 120px !important;
  border-radius: 5px;
  background-color: #f2f2f2;
  border: 1px solid #c0c0c0;
  color: #4330ff;
  margin-bottom: 0.5em;
  border-width: 1px;
}

.cancel-note-link, .cancel-pw-button {
  margin-right: 20px;
  cursor: pointer;
  color: #32c3b5 !important;
  text-decoration: underline !important;
}

.error-color {
  color: #ff2e2e;
}

.success-color {
  color: #38bb15;
}

.margin-top-10 {
  margin-top: 10px;
}

.react-modal {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  height: 195px;
  width: 300px;
  border: 1px solid #ccc;
  background: #fff;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 10px;
  outline: none;
  padding-top: 20px;
}
.react-modal .modal-menu-title {
  color: #c0c0c0;
  width: 100%;
  text-align: center;
  font-size: 12px;
}
.react-modal .modal-menu-item {
  cursor: pointer;
  color: #4330ff;
  width: 100%;
  text-align: center;
  border: none;
  background-color: white;
}
.react-modal .modal-menu-item a {
  text-decoration: none;
  color: #2d7cbf !important;
}
.react-modal .modal-menu-divider {
  width: 100%;
  border-top: 1px solid #eaeaea;
  margin: 10px 0px 10px 0px;
  padding: 0px;
}
.react-modal.note-modal {
  height: 160px;
}
.react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal, .react-modal.closing-details {
  padding: 45px;
}
.react-modal.error-modal .close-modal, .react-modal.info-modal .close-modal, .react-modal.evaluation-modal .close-modal, .react-modal.closing-details .close-modal {
  background-color: #fa504b;
  border-color: #fa504b;
  margin: auto;
  display: block;
}
.react-modal.error-modal .close-modal.btn-confirm, .react-modal.info-modal .close-modal.btn-confirm, .react-modal.evaluation-modal .close-modal.btn-confirm, .react-modal.closing-details .close-modal.btn-confirm {
  color: #ffffff;
  background-color: #606060;
  border-color: #606060;
}
.react-modal.error-modal .close-modal.btn-confirm:hover, .react-modal.info-modal .close-modal.btn-confirm:hover, .react-modal.evaluation-modal .close-modal.btn-confirm:hover, .react-modal.closing-details .close-modal.btn-confirm:hover {
  background-color: #c0c0c0;
  border-color: #c0c0c0;
}
.react-modal.error-modal .close-modal:hover, .react-modal.info-modal .close-modal:hover, .react-modal.evaluation-modal .close-modal:hover, .react-modal.closing-details .close-modal:hover {
  border-color: #fb736f;
  background-color: #fb736f;
}
.react-modal.error-modal .close-modal a, .react-modal.info-modal .close-modal a, .react-modal.evaluation-modal .close-modal a, .react-modal.closing-details .close-modal a {
  color: #ffffff;
}
.react-modal.error-modal .close-modal a:hover, .react-modal.info-modal .close-modal a:hover, .react-modal.evaluation-modal .close-modal a:hover, .react-modal.closing-details .close-modal a:hover {
  text-decoration: none;
}
.react-modal.evaluation-modal {
  width: 40%;
  height: fit-content;
  padding: 35px 20px 20px;
}

.subheader {
  padding: 5px;
  padding-left: 10px;
  color: #404040;
  background: #dcdcdc;
  font-size: 20px;
  margin-top: 20px;
}
.subheader.centered {
  text-align: center;
}

.dim {
  opacity: 0.6;
  cursor: default;
}

.dim:hover {
  background: transparent !important;
}

.center {
  text-align: center;
}

.right {
  text-align: right;
}

.blue-header {
  color: #4330ff;
}

.bold {
  font-weight: bold;
}

.red {
  color: #AA0000 !important;
}

.margin-bottom-10 {
  margin-bottom: 10px;
}

.margin-top-8 {
  margin-top: 8px;
}

button.standard {
  cursor: pointer;
  margin-top: 10px;
  width: 140px !important;
  border-radius: 5px;
  background-color: #4330ff;
  border: 1px solid #c0c0c0;
  color: #f2f2f2;
  margin-bottom: 0.5em;
}

button.cancel {
  cursor: pointer;
  margin-top: 10px;
  width: 140px !important;
  border-radius: 5px;
  background-color: #f2f2f2;
  border: 1px solid #c0c0c0;
  color: #4330ff;
  margin-bottom: 0.5em;
}
button.cancel:hover {
  cursor: pointer;
}
button.cancel:disabled {
  cursor: not-allowed;
}

button.submit {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  margin: 0 20px 20px 20px;
  height: 40px;
  min-width: 120px;
  width: calc(50% - 2px);
  border-radius: 5px;
  background: #4330ff;
  color: white;
}
button.submit:hover {
  cursor: pointer;
}
button.submit:disabled {
  cursor: not-allowed;
}

.no-results-message {
  text-align: center;
  font-weight: bold;
  margin-top: 30%;
}

.lb-highlight {
  background-color: #ffebbb;
}

.splash-screen {
  height: 100vh;
  width: 100vw;
  background-color: #4330ff;
  transition: visibility 1s, opacity 0.5s linear;
  position: absolute;
  visibility: visible;
  opacity: 1;
  top: 0;
}
.splash-screen.loaded {
  visibility: hidden;
  opacity: 0;
}
.splash-screen .splash-logo {
  margin: 100px 0px;
}
.splash-screen .splash-logo img {
  width: 50%;
  max-width: 950px;
  margin: auto;
  display: block;
}
.splash-screen .spinner-container {
  text-align: center;
  color: #fff;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  font-size: 3em;
}
.splash-screen .spinner-container .fa-spin {
  position: relative;
  top: 40%;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 585px) {
  .react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal {
    width: 90%;
    padding: 35px;
  }
}
/* Small devices (portrait tablets and large phones, 767px and under) */
/* No greater than 767px, no less than 586px */
@media only screen and (max-width: 767px) and (min-width: 586px) {
  .react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal {
    width: 75%;
  }
}
/* Large devices (laptops/desktops, 768px and up) */
@media only screen and (min-width: 768px) {
  .react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal {
    max-width: 596px;
    width: 90%;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/App/app.scss","webpack://./src/components/App/app.css","webpack://./src/app/variables.scss"],"names":[],"mappings":"AAEA;EACE,2BAAA;ACDF;;ADIA;EACE,kBAAA;ACDF;;ADIA;EACE,4CAAA;EACA,YAAA;ACDF;;ADIA;EACE,sBAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;ACDF;;ADIA;EACE,gBAAA;ACDF;;ADIA;EACE,gBAAA;ACDF;;ADIA;EACE;IAAO,uBAAA;ECAP;EDCA;IAAK,yBAAA;ECEL;AACF;ADAA;EACE,kBAAA;EACA,WAAA;EACA,OAAA;EACA,yBEbY;ADed;;ADCA;EACE,aAAA;ACEF;;ADCA;EACE,WAAA;ACEF;;ADAA;EACE,YAAA;ACGF;;ADCA;EACE,YAAA;ACEF;;ADAA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBErDc;EFsDd,yBAAA;EACA,cEtCY;EFuCZ,oBAAA;EACA,iBAAA;ACGF;;ADDA;EACE,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,qCAAA;ACIF;;ADFA;EACE,cExEY;AD6Ed;;ADFA;EACE,cE9Ec;ADmFhB;;ADFA;EAAiB,gBAAA;ACMjB;;ADHA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,iCAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;ACMF;ADLE;EACE,cEzFU;EF0FV,WAAA;EACA,kBAAA;EACA,eAAA;ACOJ;ADLE;EACE,eAAA;EACA,cEnFU;EFoFV,WAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;ACOJ;ADNI;EACE,qBAAA;EACA,yBAAA;ACQN;ADLE;EACE,WAAA;EACA,6BAAA;EACA,yBAAA;EACA,YAAA;ACOJ;ADLE;EACE,aAAA;ACOJ;ADLE;EACE,aAAA;ACOJ;ADNI;EACE,yBErGE;EFsGF,qBEtGE;EFuGF,YAAA;EACA,cAAA;ACQN;ADPM;EACE,cAAA;EACA,yBE3HW;EF4HX,qBE5HW;ADqInB;ADRQ;EACE,yBE/HI;EFgIJ,qBEhII;AD0Id;ADPM;EACE,qBElHU;EFmHV,yBEnHU;AD4HlB;ADPM;EACE,cAAA;ACSR;ADRQ;EACE,qBAAA;ACUV;ADLE;EACE,UAAA;EACA,mBAAA;EACA,uBAAA;ACOJ;;ADHA;EACE,YAAA;EACA,kBAAA;EACA,cEvJU;EFwJV,mBE5JqB;EF6JrB,eAAA;EACA,gBAAA;ACMF;ADLE;EACE,kBAAA;ACOJ;;ADJA;EACE,YAAA;EACA,eAAA;ACOF;;ADLA;EACE,kCAAA;ACQF;;ADNA;EAAU,kBAAA;ACUV;;ADTA;EAAS,iBAAA;ACaT;;ADXA;EAAe,cE9JD;AD6Kd;;ADbA;EAAQ,iBAAA;ACiBR;;ADfA;EAAO,yBAAA;ACmBP;;ADjBA;EAAmB,mBAAA;ACqBnB;;ADpBA;EAAe,eAAA;ACwBf;;ADtBA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBE5KY;EF6KZ,yBAAA;EACA,cE/Lc;EFgMd,oBAAA;ACyBF;;ADtBA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBExMc;EFyMd,yBAAA;EACA,cEzLY;EF0LZ,oBAAA;ACyBF;ADxBE;EACE,eAAA;AC0BJ;ADxBE;EACI,mBAAA;AC0BN;;ADtBA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBE7MY;EF8MZ,YAAA;ACyBF;ADxBE;EACE,eAAA;AC0BJ;ADxBE;EACI,mBAAA;AC0BN;;ADtBA;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;ACyBF;;ADtBA;EACE,yBAAA;ACyBF;;ADtBA;EACE,aAAA;EACA,YAAA;EACA,yBEpOY;EFuOZ,8CAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,MAAA;ACyBF;ADxBE;EACE,kBAAA;EACA,UAAA;AC0BJ;ADxBE;EACE,iBAAA;AC0BJ;ADzBI;EACE,UAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AC2BN;ADxBE;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AC0BJ;ADzBI;EACE,kBAAA;EACA,QAAA;AC2BN;;ADtBA,iDAAA;AACA;EACE;IACE,UAAA;IACA,aAAA;ECyBF;AACF;ADvBA,uEAAA;AACA,8CAAA;AACA;EACE;IACE,UAAA;ECyBF;AACF;ADvBA,mDAAA;AACA;EACE;IACE,gBAAA;IACA,UAAA;ECyBF;AACF","sourcesContent":["@import '../../app/variables.scss';\n\nhtml, body {\n  min-width: unset !important;\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  animation: App-logo-spin infinite 20s linear;\n  height: 80px;\n}\n\n.App-header {\n  background-color: #222;\n  height: 150px;\n  padding: 20px;\n  color: white;\n}\n\n.App-title {\n  font-size: 1.5em;\n}\n\n.App-intro {\n  font-size: large;\n}\n\n@keyframes App-logo-spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.loading-page {\n  position: absolute;\n  width: 100%;\n  left: 0;\n  background-color: $evanta-blue;\n}\n\n.hide {\n  display: none;\n}\n\n.clear {\n  clear: both;\n}\n.helper-text:hover{\n  cursor: help;\n}\n\n// Notes related styles\n.note-buttons {\n  float: right;\n}\n.save-note-button {\n  cursor: pointer;\n  margin-top: 10px;\n  width: 120px !important;\n  border-radius: 5px;\n  background-color: $lightest-gray;\n  border: 1px solid $medium-gray;\n  color: $evanta-blue;\n  margin-bottom: 0.5em;\n  border-width: 1px;\n}\n.cancel-note-link, .cancel-pw-button {\n  margin-right: 20px;\n  cursor: pointer;\n  color: $teal !important;\n  text-decoration: underline !important;\n}\n.error-color {\n  color: $error-color;\n}\n\n.success-color {\n  color: $success-color;\n}\n\n.margin-top-10 { margin-top: 10px; }\n\n// Modal\n.react-modal {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  height: 195px;\n  width: 300px;\n  border: 1px solid #ccc;\n  background: #fff;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  border-radius: 10px;\n  outline: none;\n  padding-top: 20px;\n  .modal-menu-title {\n    color: $medium-gray;\n    width: 100%;\n    text-align: center;\n    font-size: 12px;\n  }\n  .modal-menu-item {\n    cursor: pointer;\n    color: $evanta-blue;\n    width: 100%;\n    text-align: center;\n    border: none;\n    background-color: white;\n    a {\n      text-decoration: none;\n      color: $blue !important;\n    }\n  }\n  .modal-menu-divider {\n    width: 100%;\n    border-top: 1px solid $light-gray;\n    margin: 10px 0px 10px 0px;\n    padding: 0px;\n  }\n  &.note-modal{\n    height: 160px;\n  }\n  &.error-modal, &.info-modal, &.evaluation-modal, &.closing-details {\n    padding: 45px;\n    .close-modal {\n      background-color: $solar;\n      border-color: $solar;\n      margin: auto;\n      display: block;\n      &.btn-confirm{\n        color: #ffffff;\n        background-color: $medium-dark-gray;\n        border-color: $medium-dark-gray;\n        &:hover{\n          background-color: $medium-gray;\n          border-color: $medium-gray;\n        }\n      }\n      &:hover{\n        border-color: $solar-secondary;\n        background-color: $solar-secondary;\n      }\n      a {\n        color: #ffffff;\n        &:hover{\n          text-decoration: none;\n        }\n      }\n    }\n  }\n  &.evaluation-modal {\n    width: 40%;\n    height: fit-content;\n    padding: 35px 20px 20px;\n  }\n}\n\n.subheader {\n  padding: 5px;\n  padding-left: 10px;\n  color: $dark-gray;\n  background: $medium-lightest-gray;\n  font-size: 20px;\n  margin-top: 20px;\n  &.centered {\n    text-align: center;\n  }\n}\n.dim {\n  opacity: 0.6;\n  cursor: default;\n}\n.dim:hover {\n  background: transparent !important;\n}\n.center { text-align: center; }\n.right { text-align: right; }\n\n.blue-header { color: $evanta-blue; }\n\n.bold { font-weight: bold; }\n\n.red { color: #AA0000 !important; }\n\n.margin-bottom-10 {margin-bottom: 10px;}\n.margin-top-8 {margin-top: 8px;}\n\nbutton.standard {\n  cursor: pointer;\n  margin-top: 10px;\n  width: 140px !important;\n  border-radius: 5px;\n  background-color: $evanta-blue;\n  border: 1px solid $medium-gray;\n  color: $lightest-gray;\n  margin-bottom: 0.5em;\n}\n\nbutton.cancel {\n  cursor: pointer;\n  margin-top: 10px;\n  width: 140px !important;\n  border-radius: 5px;\n  background-color: $lightest-gray;\n  border: 1px solid $medium-gray;\n  color: $evanta-blue;\n  margin-bottom: 0.5em;\n  &:hover {\n    cursor: pointer;\n  }\n  &:disabled {\n      cursor: not-allowed;\n  }\n}\n\nbutton.submit {\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  margin: 0 20px 20px 20px;\n  height: 40px;\n  min-width: 120px;\n  width: calc(50% - 2px);\n  border-radius: 5px;\n  background: $evanta-blue;\n  color: white;\n  &:hover {\n    cursor: pointer;\n  }\n  &:disabled {\n      cursor: not-allowed;\n  }\n}\n\n.no-results-message {\n  text-align: center;\n  font-weight: bold;\n  margin-top: 30%;\n}\n\n.lb-highlight {\n  background-color: #ffebbb;\n}\n\n.splash-screen {\n  height: 100vh;\n  width: 100vw;\n  background-color: $evanta-blue;\n  -webkit-transition: visibility 1s, opacity 0.5s linear;\n  -ms-transition: visibility 1s, opacity 0.5s linear;\n  transition: visibility 1s, opacity 0.5s linear;\n  position: absolute;\n  visibility: visible;\n  opacity: 1;\n  top: 0;\n  &.loaded {\n    visibility: hidden;\n    opacity: 0;\n  }\n  .splash-logo {\n    margin: 100px 0px;\n    img {\n      width: 50%;\n      max-width: 950px;\n      margin: auto;\n      display: block;\n    }\n  }\n  .spinner-container {\n    text-align: center;\n    color: #fff;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    font-size: 3em;\n    .fa-spin {\n      position: relative;\n      top: 40%;\n    }\n  }\n}\n\n/* Extra small devices (phones, 600px and down) */\n@media only screen and (max-width: 585px) {\n  .react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal {\n    width: 90%;\n    padding: 35px;\n  }\n}\n/* Small devices (portrait tablets and large phones, 767px and under) */\n/* No greater than 767px, no less than 586px */\n@media only screen and (max-width:767px) and (min-width:586px) {\n  .react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal {\n    width: 75%;\n  }\n}\n/* Large devices (laptops/desktops, 768px and up) */\n@media only screen and (min-width: 768px) {\n  .react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal {\n    max-width: 596px;\n    width: 90%;\n  }\n}\n","html, body {\n  min-width: unset !important;\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  animation: App-logo-spin infinite 20s linear;\n  height: 80px;\n}\n\n.App-header {\n  background-color: #222;\n  height: 150px;\n  padding: 20px;\n  color: white;\n}\n\n.App-title {\n  font-size: 1.5em;\n}\n\n.App-intro {\n  font-size: large;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.loading-page {\n  position: absolute;\n  width: 100%;\n  left: 0;\n  background-color: #4330ff;\n}\n\n.hide {\n  display: none;\n}\n\n.clear {\n  clear: both;\n}\n\n.helper-text:hover {\n  cursor: help;\n}\n\n.note-buttons {\n  float: right;\n}\n\n.save-note-button {\n  cursor: pointer;\n  margin-top: 10px;\n  width: 120px !important;\n  border-radius: 5px;\n  background-color: #f2f2f2;\n  border: 1px solid #c0c0c0;\n  color: #4330ff;\n  margin-bottom: 0.5em;\n  border-width: 1px;\n}\n\n.cancel-note-link, .cancel-pw-button {\n  margin-right: 20px;\n  cursor: pointer;\n  color: #32c3b5 !important;\n  text-decoration: underline !important;\n}\n\n.error-color {\n  color: #ff2e2e;\n}\n\n.success-color {\n  color: #38bb15;\n}\n\n.margin-top-10 {\n  margin-top: 10px;\n}\n\n.react-modal {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  height: 195px;\n  width: 300px;\n  border: 1px solid #ccc;\n  background: #fff;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  border-radius: 10px;\n  outline: none;\n  padding-top: 20px;\n}\n.react-modal .modal-menu-title {\n  color: #c0c0c0;\n  width: 100%;\n  text-align: center;\n  font-size: 12px;\n}\n.react-modal .modal-menu-item {\n  cursor: pointer;\n  color: #4330ff;\n  width: 100%;\n  text-align: center;\n  border: none;\n  background-color: white;\n}\n.react-modal .modal-menu-item a {\n  text-decoration: none;\n  color: #2d7cbf !important;\n}\n.react-modal .modal-menu-divider {\n  width: 100%;\n  border-top: 1px solid #eaeaea;\n  margin: 10px 0px 10px 0px;\n  padding: 0px;\n}\n.react-modal.note-modal {\n  height: 160px;\n}\n.react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal, .react-modal.closing-details {\n  padding: 45px;\n}\n.react-modal.error-modal .close-modal, .react-modal.info-modal .close-modal, .react-modal.evaluation-modal .close-modal, .react-modal.closing-details .close-modal {\n  background-color: #fa504b;\n  border-color: #fa504b;\n  margin: auto;\n  display: block;\n}\n.react-modal.error-modal .close-modal.btn-confirm, .react-modal.info-modal .close-modal.btn-confirm, .react-modal.evaluation-modal .close-modal.btn-confirm, .react-modal.closing-details .close-modal.btn-confirm {\n  color: #ffffff;\n  background-color: #606060;\n  border-color: #606060;\n}\n.react-modal.error-modal .close-modal.btn-confirm:hover, .react-modal.info-modal .close-modal.btn-confirm:hover, .react-modal.evaluation-modal .close-modal.btn-confirm:hover, .react-modal.closing-details .close-modal.btn-confirm:hover {\n  background-color: #c0c0c0;\n  border-color: #c0c0c0;\n}\n.react-modal.error-modal .close-modal:hover, .react-modal.info-modal .close-modal:hover, .react-modal.evaluation-modal .close-modal:hover, .react-modal.closing-details .close-modal:hover {\n  border-color: #fb736f;\n  background-color: #fb736f;\n}\n.react-modal.error-modal .close-modal a, .react-modal.info-modal .close-modal a, .react-modal.evaluation-modal .close-modal a, .react-modal.closing-details .close-modal a {\n  color: #ffffff;\n}\n.react-modal.error-modal .close-modal a:hover, .react-modal.info-modal .close-modal a:hover, .react-modal.evaluation-modal .close-modal a:hover, .react-modal.closing-details .close-modal a:hover {\n  text-decoration: none;\n}\n.react-modal.evaluation-modal {\n  width: 40%;\n  height: fit-content;\n  padding: 35px 20px 20px;\n}\n\n.subheader {\n  padding: 5px;\n  padding-left: 10px;\n  color: #404040;\n  background: #dcdcdc;\n  font-size: 20px;\n  margin-top: 20px;\n}\n.subheader.centered {\n  text-align: center;\n}\n\n.dim {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.dim:hover {\n  background: transparent !important;\n}\n\n.center {\n  text-align: center;\n}\n\n.right {\n  text-align: right;\n}\n\n.blue-header {\n  color: #4330ff;\n}\n\n.bold {\n  font-weight: bold;\n}\n\n.red {\n  color: #AA0000 !important;\n}\n\n.margin-bottom-10 {\n  margin-bottom: 10px;\n}\n\n.margin-top-8 {\n  margin-top: 8px;\n}\n\nbutton.standard {\n  cursor: pointer;\n  margin-top: 10px;\n  width: 140px !important;\n  border-radius: 5px;\n  background-color: #4330ff;\n  border: 1px solid #c0c0c0;\n  color: #f2f2f2;\n  margin-bottom: 0.5em;\n}\n\nbutton.cancel {\n  cursor: pointer;\n  margin-top: 10px;\n  width: 140px !important;\n  border-radius: 5px;\n  background-color: #f2f2f2;\n  border: 1px solid #c0c0c0;\n  color: #4330ff;\n  margin-bottom: 0.5em;\n}\nbutton.cancel:hover {\n  cursor: pointer;\n}\nbutton.cancel:disabled {\n  cursor: not-allowed;\n}\n\nbutton.submit {\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  margin: 0 20px 20px 20px;\n  height: 40px;\n  min-width: 120px;\n  width: calc(50% - 2px);\n  border-radius: 5px;\n  background: #4330ff;\n  color: white;\n}\nbutton.submit:hover {\n  cursor: pointer;\n}\nbutton.submit:disabled {\n  cursor: not-allowed;\n}\n\n.no-results-message {\n  text-align: center;\n  font-weight: bold;\n  margin-top: 30%;\n}\n\n.lb-highlight {\n  background-color: #ffebbb;\n}\n\n.splash-screen {\n  height: 100vh;\n  width: 100vw;\n  background-color: #4330ff;\n  -webkit-transition: visibility 1s, opacity 0.5s linear;\n  -ms-transition: visibility 1s, opacity 0.5s linear;\n  transition: visibility 1s, opacity 0.5s linear;\n  position: absolute;\n  visibility: visible;\n  opacity: 1;\n  top: 0;\n}\n.splash-screen.loaded {\n  visibility: hidden;\n  opacity: 0;\n}\n.splash-screen .splash-logo {\n  margin: 100px 0px;\n}\n.splash-screen .splash-logo img {\n  width: 50%;\n  max-width: 950px;\n  margin: auto;\n  display: block;\n}\n.splash-screen .spinner-container {\n  text-align: center;\n  color: #fff;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  font-size: 3em;\n}\n.splash-screen .spinner-container .fa-spin {\n  position: relative;\n  top: 40%;\n}\n\n/* Extra small devices (phones, 600px and down) */\n@media only screen and (max-width: 585px) {\n  .react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal {\n    width: 90%;\n    padding: 35px;\n  }\n}\n/* Small devices (portrait tablets and large phones, 767px and under) */\n/* No greater than 767px, no less than 586px */\n@media only screen and (max-width: 767px) and (min-width: 586px) {\n  .react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal {\n    width: 75%;\n  }\n}\n/* Large devices (laptops/desktops, 768px and up) */\n@media only screen and (min-width: 768px) {\n  .react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal {\n    max-width: 596px;\n    width: 90%;\n  }\n}\n\n","// Font colors\n$success-color: #38bb15;\n$warning-color: #feb52b;\n$error-color: #ff2e2e;\n$link-color: #428bca;\n\n$blue: #2d7cbf;\n$blue-light-gray: #d4e4e9;\n\n$lightest-gray: #f2f2f2;\n$light-gray: #eaeaea;\n$medium-lightest-gray: #dcdcdc;\n$medium-light-gray: #909092;\n$medium-gray: #c0c0c0;\n$medium-dark-gray: #606060;\n$dark-gray: #404040;\n\n$teal: #32c3b5;\n$gold: #f2b130;\n\n$light-base: #006AC7;\n$light-active: #264A82;\n$success-base: #00A76D;\n\n$eblack: #282829;\n$egrey: #dcddde;\n$evanta-blue: #4330ff;\n$evanta-blue-secondary: #5c4ee5;\n$gartner-blue: #002869;\n$active-slider: #3fe85c;\n$solar: #fa504b;\n$solar-secondary: #fb736f;\n$solar-tertiary: #DE0A01;\n\n\n// Font sizes\n$biggest-header: 36px;\n$big-header: 28px;\n$larger: 20px;\n$large: 16px;\n$medium: 14px;\n$small: 13px;\n$smaller: 12px;\n$tiny: 11px;\n\n// Homepage colors\n// $goldLight: #F9D889;\n// $goldPrimary: #F4B213;\n// $goldDark: #92451C;\n// $greenLight: #CDE3A5;\n// $greenPrimary: #9CC84B;\n// $greenDark: #416428;\n// $mintLight: #95E1DA;\n// $mintPrimary: #2BC4B6;\n// $mintDark: #00566B;\n// $purpleLight: #C6B1D4;\n// $purplePrimary: #8D64AA;\n// $purpleDark: #46295B;\n\n$goldLight: #F9D783;\n$goldPrimary: #92451C;\n$goldDark: #F5B51D;\n$greenLight: #C7E09A;\n$greenPrimary: #416428;\n$greenDark: #A0CA51;\n$mintLight: #8EDFD8;\n$mintPrimary: #02576C;\n$mintDark: #33C7B9;\n$purpleLight: #C3ADD2;\n$purplePrimary: #513465;\n$purpleDark: #9068AD;\n\n\n// virtual portal colors\n$vp-dark-gray: #6D6E71;\n$vp-black: #2C2C2C;\n$vp-bright-red: #FA504B;\n$vp-dark-gray-50op: rgba(109, 110, 113, 0.5)\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
